import { all } from 'redux-saga/effects';
import auth from './auth';
import list from './list';

export default function* rootSaga() {
  yield all([auth(), list()]);
}
